export * from './IconPolygonPurple';
